// extracted by mini-css-extract-plugin
var _1 = "PrimaryRegistrationStartMultipleV2-module__buttonWrapper--FrOSX";
var _2 = "PrimaryRegistrationStartMultipleV2-module__contentContainer--cVK8A";
var _3 = "PrimaryRegistrationStartMultipleV2-module__fullScreenContainer--VdICx";
var _4 = "PrimaryRegistrationStartMultipleV2-module__studentCard--ODCk6";
var _5 = "PrimaryRegistrationStartMultipleV2-module__studentCardAvatar--uPfjR";
var _6 = "PrimaryRegistrationStartMultipleV2-module__studentCardName--z5wPU";
var _7 = "PrimaryRegistrationStartMultipleV2-module__studentCardPlanLabel--u6YBY";
var _8 = "PrimaryRegistrationStartMultipleV2-module__studentCardTextContainer--lNJXk";
var _9 = "PrimaryRegistrationStartMultipleV2-module__studentCardWrapper--KEooJ";
var _a = "PrimaryRegistrationStartMultipleV2-module__title--YL4M6";
export { _1 as "buttonWrapper", _2 as "contentContainer", _3 as "fullScreenContainer", _4 as "studentCard", _5 as "studentCardAvatar", _6 as "studentCardName", _7 as "studentCardPlanLabel", _8 as "studentCardTextContainer", _9 as "studentCardWrapper", _a as "title" }
